import { render, staticRenderFns } from "./fast_preview.vue?vue&type=template&id=7813bc4e&scoped=true&"
import script from "./fast_preview.vue?vue&type=script&lang=js&"
export * from "./fast_preview.vue?vue&type=script&lang=js&"
import style0 from "./fast_preview.vue?vue&type=style&index=0&id=7813bc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813bc4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7813bc4e')) {
      api.createRecord('7813bc4e', component.options)
    } else {
      api.reload('7813bc4e', component.options)
    }
    module.hot.accept("./fast_preview.vue?vue&type=template&id=7813bc4e&scoped=true&", function () {
      api.rerender('7813bc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inbox/preview/fast_preview.vue"
export default component.exports